import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import WithRouter from 'custom/withRouter';
import { selectSettingsModel } from 'selectors/entitySelector';
import { settingsCrumb } from 'utils/breadcrumbInfo';
import LOOKUP from 'constants/lookup';
import { updateSettings, getSettings, lockPinPassword } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { formInput, clearFormInput } from 'actions/FormActions';
// Basic Components
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import TextInput from 'screens/components/basic/TextInput';
import CardSimple from 'screens/components/basic/CardSimple';
import DecimalInput from 'screens/components/basic/DecimalInput';
import MaskedTextInput from 'screens/components/advanced/MaskedTextInput';
import Grid from 'screens/components/basic/Grid';
import NumberInput from 'screens/components/basic/NumberInput';
import ImageUpload from 'screens/components/basic/ImageUpload';

const COMPNAME = 'SettingsPage';

class SettingPage extends Component {
    constructor(props) {
        super(props);

        //this.lockPinPassword = this.lockPinPassword.bind(this);
    }

    componentWillMount() {
        this.props.getSettings(this.props.branchId, COMPNAME);
    }

    // is SUCCEEDED or FAILED
    //check if the Save Success or SaveError happened
    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure();
        }

        if (newProps.applicationSettings !== undefined && newProps.applicationSettings !== this.props.applicationSettings) {
            if (!newProps.applicationSettings.enablePinPasswordOnPOS) {
                this.lockPinPassword();
            }
        }
    }

    componentDidUpdate(prevProps) {
        // Reset 'PIN in seconds' form input when the 'Auto Logout PIN' is inactive
        if (prevProps.isAutoLogoutPinEnabled != this.props.isAutoLogoutPinEnabled && !this.props.isAutoLogoutPinEnabled) {
            this.props.clearFormInput(`${COMPNAME}${LOOKUP.menu.admin.setting.logoutPinAfterSeconds.name}`)
        } else if (prevProps.isAutoLogoutPinEnabled != this.props.isAutoLogoutPinEnabled && this.props.isAutoLogoutPinEnabled) {
            this.props.formInput(30, `${COMPNAME}${LOOKUP.menu.admin.setting.logoutPinAfterSeconds.name}`)
        }

        // Disable 'Auto Logout PIN' when the PIN passward is inactive
        if (prevProps.isPinEnabled != this.props.isPinEnabled && !this.props.isPinEnabled) {
            this.props.formInput(false, `${COMPNAME}IsAutoLogoutPinEnabled`)
        }
    }

    updateSettings = () => {
        const setting = this.props.settingModel;
        this.props.updateSettings(setting, COMPNAME);
    }

    //when data is saved successfully
    saveSuccess = () => {
        this.redirectToGeneralSetting();
        this.props.showSuccess(LOOKUP.device.applicationSettings.saved);
    }

    lockPinPassword() {
        this.props.lockPinPassword();
    }

    redirectToGeneralSetting = () => {
        this.props.navigate("/");
    }

    //when data is not saved, failure
    saveFailure = () => {
        this.props.showError(LOOKUP.device.applicationSettings.error);
    }

    changePOSStyle = () => {
        if (localStorage.getItem("classic") != 1) {
            localStorage.setItem("classic", 1);
        } else {
            localStorage.removeItem("classic");
        }

        window.location.reload();
    }

    render() {
        const p = this.props;
        const s = this.state;
        const prerollCategory = LOOKUP.menu.admin.setting.prerollCategoryIdOption;

        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active">{LOOKUP.menu.admin.setting.text}</li>
                </ol>
                <h2>{LOOKUP.menu.admin.setting.text}</h2>
            </div>
        );
        return (
            <Grid headerContent={settingsCrumb}>
                <CardSimple title="System Settings" className="purpleText p-1 mt-5">
                    {/* <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                disabled={true}
                                fullWidth={true}
                                name={`${COMPNAME}Id`}
                                floatingLabelText={LOOKUP.menu.admin.setting.tokenName.label}
                                hintText={LOOKUP.menu.admin.setting.tokenName.hintText}
                                maxLength={50}
                                style={{ display: "none" }} />
                        </div> {/* .col for token name 
                    </div> */}
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                disabled={true}
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.tokenName.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.tokenName.label}
                                hintText={LOOKUP.menu.admin.setting.tokenName.hintText}
                                maxLength={50} />
                        </div> {/* .col for token name */}
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                disabled={true}
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.deviceKeyName.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.deviceKeyName.label}
                                hintText={LOOKUP.menu.admin.setting.deviceKeyName.hintText}
                                maxLength={50} />
                        </div> {/* .col for device key name */}
                    </div> {/* .row */}

                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <DecimalInput
                                type="number"
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.salesPersonDiscountThreshold.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.salesPersonDiscountThreshold.label}
                                hintText={LOOKUP.menu.admin.setting.salesPersonDiscountThreshold.hintText}
                            />
                        </div> {/* .col for member discount percentage */}
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <DecimalInput
                                type="number"
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.memberDiscountPercentage.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.memberDiscountPercentage.label}
                                hintText={LOOKUP.menu.admin.setting.memberDiscountPercentage.hintText}
                            />
                        </div> {/* .col for member discount percentage */}
                    </div> {/* .row */}

                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <DecimalInput
                                type="number"
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.cashInAmountByDefault.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.cashInAmountByDefault.label}
                                hintText={LOOKUP.menu.admin.setting.cashInAmountByDefault.hintText}
                            />
                        </div> {/* .col for cash in Amount By Default */}
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <DecimalInput
                                type="number"
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.cashDropAmount.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.cashDropAmount.label}
                                hintText={LOOKUP.menu.admin.setting.cashDropAmount.hintText}
                            />
                        </div> {/* .col for cash drop Amount */}
                    </div> {/* .row */}

                    {
                        this.props.isVape ? null : (
                            <div className="row">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    <TextInput
                                        type="number"
                                        fullWidth={true}
                                        name={`${COMPNAME}${LOOKUP.menu.admin.setting.preRollCategoryId.name}`}
                                        floatingLabelText={LOOKUP.menu.admin.setting.preRollCategoryId.label}
                                        hintText={LOOKUP.menu.admin.setting.preRollCategoryId.hintText}
                                    />
                                </div>

                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    <TextInput
                                        type="number"
                                        fullWidth={true}
                                        name={`${COMPNAME}${LOOKUP.menu.admin.setting.doNotShowWeightProductQuantityOver.name}`}
                                        floatingLabelText={LOOKUP.menu.admin.setting.doNotShowWeightProductQuantityOver.label}
                                        hintText={LOOKUP.menu.admin.setting.doNotShowWeightProductQuantityOver.hintText}
                                    />
                                </div>
                            </div>
                        )
                    }

                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <DecimalInput
                                type="number"
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.toleranceCashOutAmount.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.toleranceCashOutAmount.label}
                                hintText={LOOKUP.menu.admin.setting.toleranceCashOutAmount.hintText}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                type="number"
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.doNotShowUnitProductQuantityOver.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.doNotShowUnitProductQuantityOver.label}
                                hintText={LOOKUP.menu.admin.setting.doNotShowUnitProductQuantityOver.hintText}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                type="number"
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.ageValidation.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.ageValidation.label}
                                hintText={LOOKUP.menu.admin.setting.ageValidation.hintText}
                            />
                        </div> {/* .col for age validation */}
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                type="number"
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.storeCreditExpiration.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.storeCreditExpiration.label}
                                hintText={LOOKUP.menu.admin.setting.storeCreditExpiration.hintText}
                            />
                        </div>
                    </div>

                    {
                        !this.props.isVape && this.props.applicationSettings && (this.props.applicationSettings.storeProvinceState == "ON" || this.props.applicationSettings.storeProvinceState == "Ontario") &&
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <TextInput
                                    fullWidth={true}
                                    name={`${COMPNAME}OCSHashKey`}
                                    floatingLabelText={"OCS Hash Key"}
                                    hintText={"OCS Hash Key"}
                                />
                            </div>
                        </div>
                    }
                    <div className="row mb-2">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}EnablePinPassword`}
                                label={"Enable Pin Password?"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}showPOSBulkImport`}
                                label={"Show POS Bulk Import"}
                            />
                        </div>{/* .col for weight product quantity  */}
                    </div>
                    {
                        this.props.isPinEnabled &&
                        <div className="row">
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt_-20">
                                <ToggleInput
                                    className="patient_status btnToggleLabel mt-4"
                                    name={`${COMPNAME}IsAutoLogoutPinEnabled`}
                                    label={"Enable Auto Logout Pin?"}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt_-20">
                                <TextInput
                                    type="number"
                                    fullWidth={true}
                                    name={`${COMPNAME}${LOOKUP.menu.admin.setting.logoutPinAfterSeconds.name}`}
                                    floatingLabelText={LOOKUP.menu.admin.setting.logoutPinAfterSeconds.label}
                                    hintText={LOOKUP.menu.admin.setting.logoutPinAfterSeconds.hintText}
                                />
                            </div>
                        </div>
                    }
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}showOpenOrders`}
                                label={"Show open order dialog?"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}showOpenOnlineOrders`}
                                label={"Show open online order dialog?"}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}HideSearchBar`}
                                label={"POS Search Bar Hide"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}DiscountNeedManagerApproval`}
                                label={"Discount manager approval?"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}RefundNeedManagerApproval`}
                                label={"Refund manager approval?"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}TaxExemptAllEnabled`}
                                label={"Enable Tax Exempt All"}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}NoSalesAllowedAfterStoreHours`}
                                label={"Prevent Sales after Store Hours?"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}StackDiscountEnable`}
                                label={"Stack Discount Enable"}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}ReceivePurchaseOrderWhenCreate`}
                                label={"PO Auto receive"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}GenericGiftCardEnabled`}
                                label={"Generic GiftCard Enabled"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}ShowAddMemberAfterSale`}
                                label={"Show Add Member Prompt?"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}OfflineProductScan`}
                                label={"Offline Product Scan?"}
                                disabled={true}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}CachingProducts`}
                                label={"Caching Products?"}
                                disabled={true}
                            />
                        </div>
                    </div>
                    {this.props.noSalesAllowedAfterStoreHours &&
                        <div className="row">
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <TextInput
                                    type="number"
                                    fullWidth={true}
                                    name={`${COMPNAME}${LOOKUP.menu.admin.setting.storeOpenHour.name}`}
                                    floatingLabelText={LOOKUP.menu.admin.setting.storeOpenHour.label}
                                    hintText={LOOKUP.menu.admin.setting.storeOpenHour.hintText}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <TextInput
                                    type="number"
                                    fullWidth={true}
                                    name={`${COMPNAME}${LOOKUP.menu.admin.setting.storeCloseHour.name}`}
                                    floatingLabelText={LOOKUP.menu.admin.setting.storeCloseHour.label}
                                    hintText={LOOKUP.menu.admin.setting.storeCloseHour.hintText}
                                />
                            </div>
                        </div>
                    }
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 pt-2">
                            <Button name="buttonSave"
                                className="pull-left btnNewBrandPOS"
                                label={"Switch Theme"}
                                primary={true}
                                onTouchTap={() => this.changePOSStyle()}
                            />
                        </div>
                    </div>
                </CardSimple>

                <CardSimple title="Info Settings" className="p-1 mt-2">
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.name.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.name.label}
                                hintText={LOOKUP.menu.admin.setting.name.hintText}
                            />
                        </div> {/* .col for branch name  */}
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <MaskedTextInput
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.phone.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.phone.label}
                                hintText={LOOKUP.menu.admin.setting.phone.hintText}
                                mask="(999)999-9999"
                            />
                        </div> {/* .col for phone number */}
                    </div> {/* .row */}
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.site.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.site.label}
                                hintText={LOOKUP.menu.admin.setting.site.hintText}
                            />
                        </div> {/* .col for site */}
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.street.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.street.label}
                                hintText={LOOKUP.menu.admin.setting.street.hintText}
                            />
                        </div> {/* .col for street */}
                    </div> {/* .row */}
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.city.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.city.label}
                                hintText={LOOKUP.menu.admin.setting.city.hintText}
                            />
                        </div> {/* .col for city */}
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.provinceState.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.provinceState.label}
                                hintText={LOOKUP.menu.admin.setting.provinceState.hintText}
                            />
                        </div> {/* .col for province */}
                    </div> {/* .row */}
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.country.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.country.label}
                                hintText={LOOKUP.menu.admin.setting.country.hintText}
                            />
                        </div> {/* .col for country */}
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <MaskedTextInput
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.postalCode.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.postalCode.label}
                                hintText={LOOKUP.menu.admin.setting.postalCode.hintText}
                                maxLength={8}
                                mask="A9A 9A9" />
                        </div> {/* .col for postal code */}
                    </div> {/* .row */}
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.email.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.email.label}
                                hintText={LOOKUP.menu.admin.setting.email.hintText}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.GSTNumber.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.GSTNumber.label}
                                hintText={LOOKUP.menu.admin.setting.GSTNumber.hintText}
                            />
                        </div>
                    </div> {/* .row */}
                </CardSimple>

                <CardSimple title="Customize Receipt" className="p-1 mt-2">
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                fullWidth={true}
                                name={`${COMPNAME}posReceiptBottomText`}
                                floatingLabelText={"Pos Receipt BottomText"}
                                hintText={"Pos Receipt BottomText"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                type="number"
                                fullWidth={true}
                                name={`${COMPNAME}${LOOKUP.menu.admin.setting.numberOfCopies.name}`}
                                floatingLabelText={LOOKUP.menu.admin.setting.numberOfCopies.label}
                                hintText={LOOKUP.menu.admin.setting.numberOfCopies.hintText}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}receiptShowEmployeeFirstName`}
                                label={"Show Employee First Name"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}receiptShowEmployeeLastName`}
                                label={"Show Employee Last Name"}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}receiptShowMemberName`}
                                label={"Show Member Name"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}receiptShowMemberSavings`}
                                label={"Show Member Savings"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}receiptShowVisitCount`}
                                label={"Show Visit Count"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}receiptShowMemberPoints`}
                                label={"Show Reward Points"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}receiptShowGSTNumber`}
                                label={"Show GST Number"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}receiptShowOrderNumber`}
                                label={"Show Order Number"}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}receiptShowProductCount`}
                                label={"Show Product Count"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}receiptShowTerminal`}
                                label={"Show Terminal"}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <ToggleInput
                                className="patient_status btnToggleLabel"
                                name={`${COMPNAME}receiptShowCreatedDate`}
                                label={"Show Created Date"}
                            />
                        </div>
                    </div>
                </CardSimple>

                <CardSimple title="Internal Message Settings" className="p-1 mt-2">
                    <div className="row">
                        <p className="col-xs-12">Recommended image size is 399px*81px to 407*81px</p>
                        <div className="col-xs-12">
                            <TextInput
                                fullWidth={true}
                                name={`${COMPNAME}internalMessage`}
                                floatingLabelText={"Internal Message"}
                                hintText={"Internal Message"}
                            />
                        </div>
                        <div className="col-xs-12">
                            <ImageUpload name={`${COMPNAME}bannerImageURL`} isInternalMessageImg={true} />
                        </div>
                    </div>
                </CardSimple>

                <br />
                {
                    this.props.applicationSettings && (this.props.applicationSettings.storeProvinceState == "ON" || this.props.applicationSettings.storeProvinceState == "Ontario") &&
                    <CardSimple title="AGCO Federal Report">
                        <div className="row">
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <TextInput
                                    fullWidth={true}
                                    name={`${COMPNAME}${LOOKUP.menu.admin.setting.crsaNumber.name}`}
                                    floatingLabelText={LOOKUP.menu.admin.setting.crsaNumber.label}
                                    hintText={LOOKUP.menu.admin.setting.crsaNumber.hintText}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <TextInput
                                    fullWidth={true}
                                    name={`${COMPNAME}${LOOKUP.menu.admin.setting.primaryContactFullName.name}`}
                                    floatingLabelText={LOOKUP.menu.admin.setting.primaryContactFullName.label}
                                    hintText={LOOKUP.menu.admin.setting.primaryContactFullName.hintText}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <TextInput
                                    fullWidth={true}
                                    name={`${COMPNAME}${LOOKUP.menu.admin.setting.primaryContactEmail.name}`}
                                    floatingLabelText={LOOKUP.menu.admin.setting.primaryContactEmail.label}
                                    hintText={LOOKUP.menu.admin.setting.primaryContactEmail.hintText}
                                />
                            </div>
                        </div> {/* .row */}
                        <div className="row">
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <TextInput
                                    fullWidth={true}
                                    name={`${COMPNAME}${LOOKUP.menu.admin.setting.secondaryContactFullName.name}`}
                                    floatingLabelText={LOOKUP.menu.admin.setting.secondaryContactFullName.label}
                                    hintText={LOOKUP.menu.admin.setting.secondaryContactFullName.hintText}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <TextInput
                                    fullWidth={true}
                                    name={`${COMPNAME}${LOOKUP.menu.admin.setting.secondaryContactEmail.name}`}
                                    floatingLabelText={LOOKUP.menu.admin.setting.secondaryContactEmail.label}
                                    hintText={LOOKUP.menu.admin.setting.secondaryContactEmail.hintText}
                                />
                            </div>
                        </div> {/* .row */}
                        <div className="row">
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <TextInput
                                    type="number"
                                    fullWidth={true}
                                    name={`${COMPNAME}${LOOKUP.menu.admin.setting.managementEmployeeCount.name}`}
                                    floatingLabelText={LOOKUP.menu.admin.setting.managementEmployeeCount.label}
                                    hintText={LOOKUP.menu.admin.setting.managementEmployeeCount.hintText}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <TextInput
                                    type="number"
                                    fullWidth={true}
                                    name={`${COMPNAME}${LOOKUP.menu.admin.setting.administrativeEmployeeCount.name}`}
                                    floatingLabelText={LOOKUP.menu.admin.setting.administrativeEmployeeCount.label}
                                    hintText={LOOKUP.menu.admin.setting.administrativeEmployeeCount.hintText}
                                />
                            </div>
                        </div> {/* .row */}
                        <div className="row">
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <TextInput
                                    type="number"
                                    fullWidth={true}
                                    name={`${COMPNAME}${LOOKUP.menu.admin.setting.salesEmployeeCount.name}`}
                                    floatingLabelText={LOOKUP.menu.admin.setting.salesEmployeeCount.label}
                                    hintText={LOOKUP.menu.admin.setting.salesEmployeeCount.hintText}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <NumberInput
                                    fullWidth={true}
                                    name={`${COMPNAME}${LOOKUP.menu.admin.setting.productionEmployeeCount.name}`}
                                    floatingLabelText={LOOKUP.menu.admin.setting.productionEmployeeCount.label}
                                    hintText={LOOKUP.menu.admin.setting.productionEmployeeCount.hintText}
                                />
                            </div>
                        </div> {/* .row */}
                        <div className="row">
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <NumberInput
                                    fullWidth={true}
                                    name={`${COMPNAME}${LOOKUP.menu.admin.setting.otherEmployeeCount.name}`}
                                    floatingLabelText={LOOKUP.menu.admin.setting.otherEmployeeCount.label}
                                    hintText={LOOKUP.menu.admin.setting.otherEmployeeCount.hintText}
                                />
                            </div>

                        </div> {/* .row */}
                    </CardSimple>
                }
                <div className="row marginRightMobile">
                    <div className="col-lg-12">
                        <Button name="buttonSave"
                            className="pull-right btnNewBrandPOS"
                            label={LOOKUP.employee.controls.saveButton}
                            primary={true}
                            onTouchTap={() => this.updateSettings()}
                        />
                        <Button
                            type="CancelButton"
                            name="buttonCancel"
                            className="pull-right btn-space btnCancelOperation"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.redirectToGeneralSetting()}
                        />
                    </div>  {/* .col */}
                </div> {/* .row */}
            </Grid>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        branchId: state.common.branchId,
        settingModel: selectSettingsModel(state, COMPNAME),
        saveSuccess: state.form.SettingsPageSaveSuccess,
        saveError: state.form.SettingsPageSaveSuccessSaveError,
        applicationSettings: state.common.applicationSettings,
        noSalesAllowedAfterStoreHours: state.form.SettingsPageNoSalesAllowedAfterStoreHours,
        isVape: state.common.applicationSettings.isVape,
        isPinEnabled: state.form[`${COMPNAME}EnablePinPassword`],
        logoutPinAfterSeconds: state.common.applicationSettings.logoutPinAfterSeconds ? state.common.applicationSettings.logoutPinAfterSeconds : null,
        isAutoLogoutPinEnabled: state.form[`${COMPNAME}IsAutoLogoutPinEnabled`]
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        getSettings: (branchId, compName) => dispatch(getSettings(branchId, compName)),
        updateSettings: (setting, compName) => dispatch(updateSettings(setting, compName)),
        lockPinPassword: () => dispatch(lockPinPassword()),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        showSuccess: (message) => dispatch(showSnackbar(message))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(SettingPage));
